module.exports = __webpack_public_path__ + "images/home/index/templates-administration-b30eb73b030a674a304633a2e67f9a41.png";